module.exports = __webpack_public_path__ + "img/web-proxy-browser.4b169eda.webp";